// SnowPacksDialog.js
import { useState, useEffect } from "react"
import { Typography, Button } from '@mui/material'
import SnowPackRemovalForm from './SnowPackRemovalForm'
import SnowPackParametersForm from './SnowPackParametersForm'
import "../../css/DemoCode.css"

/**
 * Frame for data inputs. 
 * 
 * @param {JSON} model A SWMM model in JSON format. In most cases this
 * is a 'submodel' containing only a copy of the affected sections. Using a copy allows
 * for continuous react-style editing without forcing the model to run on every keystroke.
 * @param {function} setModel Update function for updating 'model'.
 * @param {string} target The name of the object targetted by this form.
 * @param {function} setNewName Sets the new name of this object if the user modifies the name.
 * @param {function} setFullModel Sets the full model in case of any updates.
 * @returns UI for interactive swmm modeling.
 */
export default function SnowPacksDialog({ model, setModel, target, setNewName, setFullModel }) {
  const [submodel, setSubmodel] = useState()
  const [newTargetName, setNewTargetName] = useState(target)

  // Create a submodel for this editor interface.
  useEffect(()=>{
    let SNOWPACKS = {[target]:[]}
    if(model.SNOWPACKS && model.SNOWPACKS[target]){
      SNOWPACKS = {
        [target]: model.SNOWPACKS[target]
      }
    }

    setSubmodel({
      SNOWPACKS: SNOWPACKS
    })
  }, [model])

  const saveEdits = () => {
    setFullModel(prev => ({
      ...prev, 
      SNOWPACKS: {
        ...prev.SNOWPACKS, 
        [target]: model.SNOWPACKS[target]
      }
    }))
  }

  function handleChange(e) {
    setNewName(e.target.value)
    setNewTargetName(e.target.value)
  }

  function openTab(evt, tabName) {
    var i, tabcontent, tablinks
  
    // Get all elements with class="tabcontent" and hide them
    tabcontent = document.getElementsByClassName("tabcontent")
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none"
    }
  
    // Get all elements with class="tablinks" and remove the class "active"
    tablinks = document.getElementsByClassName("tablinks")
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "")
    }
  
    // Show the current tab, and add an "active" class to the button that opened the tab
    document.getElementById(tabName).style.display = "block"
    evt.currentTarget.className += " active"
  }

  /**
   * If there is a valid model, create a UI for the model.
   */
  return(
    <>
    {
      <>
        <Typography id="modal-modal-title" variant="p4" >
          <div style={{display:"flex", flexDirection: "column", padding: '10px'}}>
            <label>Snow Pack</label>
            <input style={{fontSize: '16px', background: 'rgb(50, 50, 50)', color: 'lightskyblue', border: 'none', textAlign: 'center'}} type="text" value={newTargetName} onChange={handleChange} />
          </div>
        </Typography>
        <div>
          <Button fullWidth onClick={saveEdits} >Save Edits</Button>
        </div>
        <div style={{height: "280px", background:'black', overflowY: 'hidden', paddingBottom:"120px"}}>
          {
            <>
            <div className="tab">
              <button className="tablinks active" onClick={(e)=>openTab(e, 'Parameters' )}>Parameters</button>
              <button className="tablinks" onClick={(e)=>openTab(e, 'Removal' )}>Removal</button>
            </div>
            
            <div id="Parameters" style={{display: 'block'}} className="tabcontent">
              {<SnowPackParametersForm model={model} setModel={setModel} setFullModel={setFullModel} target={target} targetType={'SNOWPACKS'} />}
            </div>
            
            <div id="Removal" className="tabcontent">
              {<SnowPackRemovalForm model={model} setModel={setModel} setFullModel={setFullModel} target={target} targetType={'SNOWPACKS'} />}
            </div>
            
            </>
          }
        </div>
        </>
      }
    </>
  )
} 